import { render, staticRenderFns } from "./DiskSpace.vue?vue&type=template&id=01c6b1b8&scoped=true&"
import script from "./DiskSpace.vue?vue&type=script&lang=js&"
export * from "./DiskSpace.vue?vue&type=script&lang=js&"
import style0 from "./DiskSpace.vue?vue&type=style&index=0&id=01c6b1b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c6b1b8",
  null
  
)

export default component.exports